
import { timeFormat, timeFromNow } from "@/utils/time";
export default {
   timeFormat,
   timeFromNow,
};
